var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkboxFilter"},_vm._l((_vm.list[_vm.type]),function(val){return _c('v-checkbox',{key:val.id,staticClass:"checkbox-item",attrs:{"label":val.name,"color":"#222426","value":val,"hide-details":""},on:{"change":_vm.change},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }